import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=e1141ee2&scoped=true&"
import script from "./EmptyList.vue?vue&type=script&lang=js&"
export * from "./EmptyList.vue?vue&type=script&lang=js&"
import style0 from "./EmptyList.vue?vue&type=style&index=0&id=e1141ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1141ee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1141ee2')) {
      api.createRecord('e1141ee2', component.options)
    } else {
      api.reload('e1141ee2', component.options)
    }
    module.hot.accept("./EmptyList.vue?vue&type=template&id=e1141ee2&scoped=true&", function () {
      api.rerender('e1141ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/EmptyList.vue"
export default component.exports